import React, { useCallback } from "react";
import { Button, Modal } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import ee from "../../../services/EventEmitter";
import { MODAL } from "../../../constants/translates";

interface Props {
  entityId: unknown;
  eventKey: string;
}

const Actions: React.FC<Props> = ({ entityId, eventKey }) => {
  const onDeleteHandler = useCallback(() => {
    Modal.confirm({
      title: MODAL.confirm_title,
      content: MODAL.confirm_delete,
      onOk: () => {
        ee.emit(eventKey, entityId);
      },
    });
  }, [entityId, eventKey]);

  return (
    <Button type="primary" onClick={onDeleteHandler}>
      <DeleteOutlined />
    </Button>
  );
};

export default Actions;
